// #region imports

// --- Angular
import { Component } from '@angular/core';

// #endregion

@Component({
  selector: 'hs-results-empty',
  templateUrl: './results-empty.component.html',
  styleUrls: ['./results-empty.component.scss']
})
export class ResultsEmptyComponent {

}
